import { ApplicationConfig, ENV } from "../types";

export const config: ApplicationConfig = {
  API_BASE_URL: "https://api.policyqa.test.unlikely.ai/api",
  ENV: ENV.TEST,
  AUTH0: {
    AUDIENCE: "",
    CLIENT_ID: "",
    DOMAIN: "",
  },
};
